import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

/**
 * 拦截器
 */
Vue.http.interceptors.push(function(req, next) {
  const token = localStorage.getItem("TOKEN");
  const supplyId = this.$route.params.supplyId;
  const supplyCentreId = this.$route.params.supplyCentreId;
  const farmId = this.$route.params.baseId;
  const carWashId = this.$route.params.carWashId;
  if (token) {
    req.headers.set("X-CA-Token", token);
    supplyId && req.headers.set("supplyId", supplyId);
    supplyCentreId && req.headers.set("supplyCentreId", supplyCentreId);
    farmId && req.headers.set("farmId", farmId);
    carWashId && req.headers.set("carWashId", carWashId);
  }
  next(res => {
    if (!res.ok) {
      this.$message.error("哦，出现了一个错误，请联系管理员");
    } else {
      if (res.body.apiStatus === -2) {
        this.$message.error(res.body.info || "操作出错了");
        this.$router.push({
          name: "login"
        });
      } else {
        if (!(res.body.apiStatus === 0 && res.body.sysStatus === 0)) {
          this.$message.error(res.body.info || "操作出错了");
        }
        // 从路由中获取动态路由参数并存入浏览器缓存中
        if (this.$route.params) {
          const params = this.$route.params;
          for (const key in params) {
            localStorage.setItem(key, params[key]);
          }
        }
      }
    }
  });
});
